import React from 'react';
import { connect } from 'react-redux';
import { ServiceModalAction } from '../../actions/ServiceModalAction';
import { Translate as t } from '../../config/Translate';

const ServiceModalQueue = ({ pendingAlerts, pendingCount, currentIndex, NavigatePrev, NavigateNext }) => {
	if (pendingCount <= 1) return null;

	const hasPrev = currentIndex > 0;
	const hasNext = currentIndex < pendingCount - 1;

	const containerStyle = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: '8px 16px',
		backgroundColor: '#f8f9fa',
		borderTop: '1px solid #dee2e6',
		fontSize: '13px',
	};

	const btnStyle = (enabled) => ({
		border: 'none',
		background: 'none',
		cursor: enabled ? 'pointer' : 'default',
		color: enabled ? '#0d6efd' : '#adb5bd',
		fontSize: '14px',
		fontWeight: 500,
		padding: '4px 8px',
	});

	return (
		<div style={containerStyle}>
			<button
				style={btnStyle(hasPrev)}
				onClick={hasPrev ? NavigatePrev : undefined}
				disabled={!hasPrev}
			>
				&laquo; {t('service.issueManager.prev')}
			</button>
			<span style={{ color: '#6c757d' }}>
				{currentIndex + 1} / {pendingCount} {t('service.issueManager.pendingAlerts')}
			</span>
			<button
				style={btnStyle(hasNext)}
				onClick={hasNext ? NavigateNext : undefined}
				disabled={!hasNext}
			>
				{t('service.issueManager.next')} &raquo;
			</button>
		</div>
	);
};

const mapState = (state) => ({
	pendingAlerts: state.ServiceModalReducer.pendingAlerts,
	pendingCount: state.ServiceModalReducer.pendingCount,
	currentIndex: state.ServiceModalReducer.currentIndex,
});

const mapDispatch = (dispatch) => ({
	NavigatePrev: () => dispatch(ServiceModalAction.NavigatePrev()),
	NavigateNext: () => dispatch(ServiceModalAction.NavigateNext()),
});

export default connect(mapState, mapDispatch)(ServiceModalQueue);
